<template>
  <div class="text-left">
    <h4 class="mt-4 text-dark-gray sm:mt-2">
      Enter the address where your checks will be mailed.
    </h4>
    <p
      v-if="!show_po_box"
      class="mb-6 text-xxs font-bold uppercase text-gray-over-dark"
    >
      Search for your address below, then select an address from the dropdown
      menu to continue.
    </p>
    <p
      v-else
      class="mb-6 text-xxs font-bold uppercase text-gray-over-dark"
    >
      Enter your PO Box details below to continue.
    </p>
    <!-- <google-places-autocomplete
      placeholder="Search"
      label="Search Address"
      :data="data"
      :toggleButton="toggleButton"
      :firstTime="firstTime"
      :stepName="stepName"
    ></google-places-autocomplete> -->
    <google-autocomplete-places
      v-if="!show_po_box"
      label="ADDRESS"
      @placechanged="onCheckAddressChange"
    />
    <template v-if="show_po_box">
      <form-field
        id="check_po_box"
        label="PO Box Number"
        :value="po_box.street1"
        placeholder="Enter your PO Box number (digits only)"
        :on-input="handlePOBox"
        name="check_po_box"
        pattern="\d*"
      />
      <form-field
        id="check_city"
        label="City"
        :value="po_box.city"
        placeholder="Enter city"
        :on-input="handlePOBox"
        name="check_city"
      />
      <form-field
        id="check_state"
        label="State"
        :value="po_box.state"
        placeholder="Enter two-letter state abbreviation"
        :on-input="handlePOBox"
        name="check_state"
      />
      <form-field
        id="check_postal_code"
        label="Postal Code"
        :value="po_box.postal_code"
        placeholder="Enter postal code"
        :on-input="handlePOBox"
        name="check_postal_code"
      />
      <dropdown-select-payment
        :options="countryOptions"
        :default="'United States'"
        :on-input="handlePOBox"
        label="Country"
        name="check_country"
      />
    </template>
    <div class="relative mt-2 flex items-start">
      <div class="flex h-6 items-center">
        <input
          id="check-show-po-box"
          v-model="show_po_box"
          name="check-show-po-box"
          type="checkbox"
          class="form-checkbox h-4 w-4 cursor-pointer rounded border-gray-300 text-yellow-500"
        />
      </div>
      <div class="ml-2 text-sm leading-6">
        <label
          for="check-show-po-box"
          class="cursor-pointer text-xs text-body-color"
        >
          Use a PO Box number instead
        </label>
      </div>
    </div>
    <div class="h-60" />
  </div>
</template>

<script>
// import GooglePlacesAutoComplete from "../../GooglePlacesAutocomplete.vue";
import FormField from '../../FormField.vue';
import GoogleAutocompletePlaces from '@/components/GoogleAutocompletePlaces.vue';
import DropdownSelectPayment from '@/components/DropdownSelectPayment.vue';

export default {
  name: 'CheckForm',
  components: {
    // "google-places-autocomplete": GooglePlacesAutoComplete,
    GoogleAutocompletePlaces,
    FormField,
    DropdownSelectPayment,
  },
  props: {
    data: Object,
    firstTime: {
      type: [Number, Boolean],
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      address: '',
      show_po_box: false,
      po_box: {
        street1: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
      },
      countryOptions: ['United States', 'Canada'],
    };
  },
  computed: {
    isValidForm: function () {
      return this.address !== '';
    },
    newPaymentMethodType() {
      return this.$store.state.payments?.newPaymentMethodType;
    },
  },
  watch: {
    isValidForm: function (isValid) {
      this.$store.commit('toggleDisabledButton', {
        bool: !isValid,
        source: 'CheckForm #2',
      });
    },
    stepName: function (val) {
      // if (val === "Payment-3" && !this.firstTime) {
      if (val === 'Payment-3' && this.newPaymentMethodType == 'check') {
        if (this.address) {
          this.onUpdate();
        } else {
          this.toggleButton(true);
        }
      }
    },
  },
  methods: {
    onCheckAddressChange(e) {
      this.address = e;
      this.onUpdate();
    },
    handlePOBox(e) {
      console.log(e?.target?.name);
      switch (e?.target?.name) {
        case 'check_po_box':
          this.po_box.street1 = e?.target?.value;
          break;
        case 'check_city':
          this.po_box.city = e?.target?.value;
          break;
        case 'check_state':
          this.po_box.state = e?.target?.value?.toUpperCase();
          break;
        case 'check_postal_code':
          this.po_box.postal_code = e?.target?.value;
          break;
      }
      if (this.countryOptions?.includes(e)) {
        this.po_box.country = e;
      }
      this.onUpdate();
    },
    onUpdate() {
      if (this.show_po_box) {
        this.onUpdatePOBox();
      } else {
        this.onUpdateAddress();
      }
    },
    onUpdatePOBox() {
      this.address = '';
      let body = {
        is_active: true,
        is_type: this.$store.state.payments.newPaymentMethodType,
        street1:
          this.po_box?.street1?.length > 0
            ? `PO Box ${this.po_box.street1}`
            : null,
        city: this.po_box?.city || null,
        state: this.po_box?.state || null,
        country: this.formatCountry(this.po_box?.country) || 'US',
        postal_code: this.po_box?.postal_code || null,
      };
      this.updateOnboardingPacket(body);

      if (
        this.po_box?.street1?.length > 0 &&
        this.po_box?.city?.length > 0 &&
        this.po_box?.state?.length > 0 &&
        this.po_box?.postal_code?.length > 0
      ) {
        this.toggleButton(false);
      } else {
        this.toggleButton(true);
      }
    },
    onUpdateAddress() {
      this.po_box = {
        street1: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
      };
      let street1Val = null;
      let body = null;
      if (
        (!this.address?.street_number || !this.address?.route) &&
        this.address?.street1_backup_value
      ) {
        street1Val = this.address?.street1_backup_value;
      } else {
        street1Val = `${this.address?.street_number} ${this.address?.route}`;
      }
      let localityVal = this.address?.locality
        ? this.address?.locality
        : this.address?.locality_backup_value
          ? this.address?.locality_backup_value
          : null;
      body = {
        is_active: true,
        is_type: this.$store.state.payments.newPaymentMethodType,
        street1: street1Val || null,
        street2: this.address?.subpremise || null,
        city: localityVal || null,
        state: this.address?.administrative_area_level_1 || null,
        country: this.formatCountry(this.address?.country) || null,
        postal_code: this.address?.postal_code || null,
      };
      this.updateOnboardingPacket(body);

      if (street1Val?.length > 0) {
        this.toggleButton(false);
      } else {
        this.toggleButton(true);
      }
    },

    formatCountry(country) {
      if (country === 'United States') {
        return 'US';
      }
      if (country === 'Canada') {
        return 'CA';
      }
      return country;
    },

    updateOnboardingPacket(body) {
      this.$store.dispatch('payments/setPaymentBody', {
        payment_method: body,
      });
    },

    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'CheckForm #1',
      });
    },
    handleSelect(value) {
      console.dir('CheckForm handleSelect');
      console.dir(value);
      this.address = value;
      this.toggleButton(false);
    },
  },
};
</script>
